import   React,
       { useEffect,
         useState,
         useContext } from 'react';
import { Typography, 
         Button,
         TextField,
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import { UTIL_useStyles,
         Spacer,
         ScrollList,
        } from "./Util";  
import { Stack } from "../util/tools";
import { CONSTS, INFO } from '../util/object';
import { arraySeqAscSort,
        arrayTimestampDesSort,
        arrayGroupIdDesSort,
        parseSliceParams,
        reportSystemException,
        map2Array,
         } from '../util/util';
import { SendMsg,
         SendNewUser,
         GetMsg,
         fetchProgram,
         fetchProgramList,
         fetchProgSequences,
         fetchClassSetupList,
         fetchGroupMembers,
         fetchClassSetup,
         updateClassSetup,
         fetchGroupList } from '../util/database';
import { SettingsRemoteRounded, SettingsSystemDaydream } from '@material-ui/icons';
import { appContext } from "./index";


const auth_useStyles = makeStyles(theme => ({
	    bot_root: {
			display: 'flex',
			flexDirection: 'row',
            justifyContent: 'flex-start',
			width: '100%',
			height: '100%',
			margin: '0',
			padding: '0',
            background: '#3a3a40',
	    },
	    left_container: {
			display: 'flex',
			flexDirection: "column",
            justifyContent: 'flex-start',
			padding: '0',
			margin: '0',
			width: "calc(100% - 280px)",
            maxWidth: '380px',
			height: "100%",
            zIndex: '100',
	    },
	    right_container: {
			display: 'flex',
			flexDirection: "row",
            justifyContent: 'space-between',        //'flex-start',
			padding: '0',
			margin: '0',
			height: "100%",
            maxWidth: '100%',
			//width: "auto",
            //background: 'yellow',
			//alignItems: "flex-start",
	    },
	    description_container: {
			display: 'flex',
			flexDirection: "column",
			alignItems: "flex-start",
			padding: '0',
			margin: '0',
			width: "auto",
			height: "100%",
            background: 'pink',
	    },
        add_roster_container: {
            position: "absolute",
            top: '0',
            left: '0',
            padding: '0',
            margin: '0',
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            background: '#444444e0',
            zIndex: '160',
        },
        add_roster_form: {
            position: 'relative',
            display: 'flex',
            //margin: 'calc(50% - 300px) auto',
            margin: 'calc(5% + 10px) auto',
            padding: '20px 20px',
            width: '500px',
            height: '300px',
            flexDirection: 'column',
            justifyContent: 'space-between',
            background: '#bfbfc3',
        },
        add_roster_inputs: {
            height: 'calc(100% - 80px)',
            width: '100%',
            margin: '0 10px',
            overflow: 'auto',
            //background: 'red',
        },
        form_title: {
            color: '#7e7f85',
            padding: '0 20px',
        },
        input_field: {

        },
	    list_wrapper: {
			display: 'flex',
            position: 'relative',
			flexDirection: "column",
			padding: '0',
			margin: '0',
			width: "160px",
			height: "100%",
            background: '#d3cfcf14',
        },
	    list_container: {
			display: 'block',   //'flex',
            position: 'relative',
			flexDirection: "column",
            justifyContent: 'flex-start',
			alignItems: "flex-start",
			padding: '8px 10px',   //'2px 10px',
			margin: '0',
			width: "100%",  //"160px",
			height: "100%",
            //background: '#d3cfcf14',
            overflow: 'auto',
	    },

	    selector_root: {
			display: 'flex',
			flexDirection: 'column',
            justifyContent: 'flex-start',
			width: '100%',
			height: "auto",
			margin: '3px',
			padding: '0',
        },
	    selector_container: {
            display: 'flex',
			flexDirection: "row",
            justifyContent: 'flex-start',
			alignItems: "flex-start",
			padding: '0px 3px 8px 3px',
			margin: '3px',
			width: "100%",
			height: "auto",
            borderRadius: '6px',
            background: '#c5c1c124',
	    },
	    title: {
			textAlign: 'center',
            fontSize: '0.9rem',
			margin: '0',
			padding: '0',
            color: '#979696',
        },
	    cmd_container: {
            display: 'flex',
			flexDirection: "row",
			alignItems: "flex-start",
            justifyContent: 'space-between',
			padding: '0',
			margin: '10px',
			width: "100%",
			height: "auto",
            flexWrap: 'wrap',
            overflow: 'auto',
	    },
        cmd_btn: {
            color: 'white',
            fontSize: '0.85rem',
            height: '65px',
            width: '100px',
            margin: '6px',
            padding: '3px',

            background: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
            borderColor: 'rgba(255,255,255,0)',
            borderRadius: '12px',
            border: '0px',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 15px -2px, rgba(0, 0, 0, 0.45) 0px 3px 12px -3px',
            justifyContent: 'center',
            alignSelf: 'center',
            zIndex: '380',
        },
        list_btn: {
            color: 'white',
            fontSize: '0.8rem',
            height: '25px',
            width: '100px',
            margin: '6px',
            padding: '3px',
            background: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
            borderColor: 'rgba(255,255,255,0)',
            borderRadius: '6px',
            border: '0px',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 15px -2px, rgba(0, 0, 0, 0.45) 0px 3px 12px -3px',
            justifyContent: 'center',
            alignSelf: 'center',
            zIndex: '380',
        },
        list_highlight_btn: {
            color: 'white',
            fontSize: '0.8rem',
            height: '25px',
            width: '100px',
            margin: '6px',
            padding: '3px',

            background: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
            borderWidth: '4px',
            borderStyle: 'solid',
            borderColor: '#279965',     // green
            borderRadius: '6px',
            //border: '0px',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 15px -2px, rgba(0, 0, 0, 0.45) 0px 3px 12px -3px',
            justifyContent: 'center',
            alignSelf: 'center',
            zIndex: '380',
        },
        select_btn: {
            color: 'white',
            fontSize: '0.6rem',
            height: '60px',
            width: '100px',
            marginBottom: '4px',
            padding: '3px',
            background: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
            borderColor: 'rgba(255,255,255,0)',
            borderRadius: '6px',
            border: '0px',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 15px -2px, rgba(0, 0, 0, 0.45) 0px 3px 12px -3px',
            justifyContent: 'center',
            alignSelf: 'center',
            zIndex: '380',
        },
        list_item: {
            display: "flex",      // not needed at item level
            flexDirection: "column",       //"row",
            flexWrap: 'wrap',
            alignItems: "flex-start",
            alignContent: 'spaceBetwen',
            color: "white",
            fontSize: '0.65rem',
            textAlign: 'center',

            padding: '10px',
            margin: '0 0 5px 0',
            width: "140px",
            height: "50px",     // 50px
            borderRadius: '5px',
            borderWidth: '0px',
            borderColor: '#ffffff',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 3px 7px -3px',
            background: '#314f78f2',        //'#3d495af2',
            zIndex: '150',
        },
        selected_list_item: {
            display: "flex",      // not needed at item level
            flexDirection: "column",       //"row",
            flexWrap: 'wrap',
            alignItems: "flex-start",
            alignContent: 'spaceBetwen',
            color: "white",
            fontSize: '0.65rem',
            textAlign: 'center',

            padding: '10px',
            margin: '0 0 5px 0',
            width: "140px",
            height: "50px",     // 50px
            borderRadius: '5px',
            borderWidth: '4px',
            borderStyle: 'solid',
            borderColor: '#279965',     // green
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 3px 7px -3px',
            background: '#314f78f2',        //'#3d495af2',
            zIndex: '150',
        },
        disabled_list_item: {
            display: "flex",      // not needed at item level
            flexDirection: "column",       //"row",
            flexWrap: 'wrap',
            alignItems: "flex-start",
            alignContent: 'spaceBetwen',
            color: '#746f6f',       //"white",
            fontSize: '0.65rem',
            textAlign: 'center',

            padding: '10px',
            margin: '0 0 5px 0',
            width: "140px",
            height: "50px",     // 50px
            borderRadius: '5px',
            borderWidth: '0px',
            borderColor: '#ffffff',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 3px 7px -3px',
            background: '#48494a50',     //'#3d495a50',
            zIndex: '150',
        },

    create_btn: {
            display: "flex",      // not needed at item level
            flexDirection: "column",       //"row",
            flexWrap: 'wrap',
            alignItems: "center",
            alignContent: 'spaceBetwen',
            textAlign: 'center',
            color: "white",
            fontSize: '0.8rem',
            fontWeight: 'bold',

            padding: '8px',
            margin: '0 0 5px 0',
            width: "140px",
            height: "35px",     // 50px
            borderRadius: '5px',
            boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 3px 7px -3px',
            background: '#053b5af2',        //'#3d495af2',
            zIndex: '150',
    },

    dev_btn_container: {
        display: 'flex',
        position: "absolute",
        right: '0',
        bottom: '50px',    //'50px',
        height: 'auto',
        width: '100%',
        padding: '5px',    //'8px 0',
        zIndex: '140',
        width: "160px",
        background: '#5c5c5cc7',
        flexDirection: 'column',
    },
    control_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
        },
		fontSize: '1.0rem',
        height: '35px',     //'6vh',
        width: '100px',
        //minWidth: '160px',
        //minHeight: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        //marginBottom: '2.5vh',
        marginTop: '5px',       // '0.7vh',
        padding: '10px',
        borderRadius: '10px',
        border: '0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '380',
        color: 'white',
        background: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
    },

    }));



// for 
const Selector = (props) => {
    const classes = auth_useStyles();
    const [ Title, setTitle ] = useState("");

    useEffect(() => {
		console.log("Selector.INIT.36: running useEffect() ", props);
		//document.getElementById('hardcode').addEventListener('click', runTest, false);
		//window.addEventListener('load', setupVideoFile, false);

    }, [1]); 


    useEffect(() => {
		console.log("seletor.395:    REFRESH   Title=",Title, " props.Highlight=", props.Hightlight);
    }, [Title, props.Highlight]); 

    
    useEffect(() => {
        if (props.Active) {
            var active = props.Active;
            //console.log("select.256:    props.Active=",active );
            setTitle(active.title);
        }
    }, [props.Active]); 


    const handleShowTopLevelList = (type) => () => {
		console.log("seletor.192:    HANDLE SHOW TOP LEVEL LIST  type=",type );
        if (type === "class_group") {INFO.bot_read_from_db = true};            // force a new db, not re-use msgs.setup
        props.ListAction(type);
    }

    const handleSelectActive = (type) => () => {
		console.log("seletor.365:    HANDLE SELECT type=",type );
        props.ViewAction(type);
    }

    return (
        <React.Fragment>
	    <div id="selector_root" className={classes.selector_root} >
			<div id="title" className={classes.title}>{props.Title}</div>

            <Button id="list_btn" className={(props.Highlight === true) ? classes.list_highlight_btn : classes.list_btn } onClick={handleShowTopLevelList(props.Type)}>
                VIEW LIST
            </Button> 
		   
            <Button id="select_btn" className={classes.select_btn} onClick={handleSelectActive(props.Subtype)}>
                {Title}
            </Button> 

        </div>
        </React.Fragment>
    )
}





// control panel for managing bot devices to conduct clinic sessions
//
export const BotAdmin = (props) => {
    const classes = auth_useStyles();
    const Classes = UTIL_useStyles();
    const [ List, setList ] = useState([]);                 // poly: active list being displayed
    const [ ListAddText, setListAddText ] = useState([]);   // poly: active list being displayed
    const [ ListType, setListType ] = useState(null);
    const [ ListTitle, setListTitle ] = useState("");
    const [ DisableSetBtn, setDisableSetBtn ] = useState(true);
    const [ ListHighlight, setListHighlight ] = useState(false);

    //const [ ActiveListStates, setActiveListStates ] = useState(null);       // poly: enabled state of items on the list, write back to db?
    //const [ ActiveMemberStates, setActiveMemberStates ] = useState(null);       // poly: enabled state of items on the list, write back to db?
    //const [ ActiveNodeStates, setActiveNodeStates ] = useState(null);       // poly: enabled state of items on the list, write back to db?
    //const [ ActiveDrillStates, setActiveDrillStates ] = useState(null);       // poly: enabled state of items on the list, write back to db?
    //const [ ActiveDrillList, setActiveDrillList ] = useState([]);       // poly: lastest devices for setup
    //const [ OrigActiveListStates, setOrigActiveListStates ] = useState([]);   // for chg state mgmt
    const [ SelectOne, setSelectOne ] = useState(true);         // poly: list being displayed
    const [ ListItemIndex, setListItemIndex ] = useState(null);         // for indirect click
    const [ IndexOverride, setIndexOverride ] = useState(null);         // direct drill select

    const [ ActiveItem, setActiveItem ] = useState(null);       // poly: buffer for Item currently selected (but not set)
    const [ ActiveRoster, setActiveRoster ] = useState(null);     // designated class list
    const [ ActiveProg, setActiveProg ] = useState(null);       // designated prog
    const [ ActiveDevice, setActiveDevice ] = useState(null);   // designated device list
    const [ ViewActiveRoster, setViewActiveRoster ] = useState(null);     // state: type we are viewing
    const [ ViewActiveProg, setViewActiveProg ] = useState(null);
    const [ ViewActiveDevice, setViewActiveDevice ] = useState(null);
    const [ ShowClassUpdate, setShowClassUpdate ] = useState(null);
    //const [ ClassButtonText, setClassButtonText ] = useState("");
    const [ ShowNewProgRun, setShowNewProgRun ] = useState(null);     // after a prog is loaded, give option to start prob (no chgs needed)
    const [ SetupChanged, setSetupChanged ] = useState(false);
    const [ ClassUpdateDisabled, setClassUpdateDisabled ] = useState(true);
    const [ DrillDisabled, setDrillDisabled ] = useState(true);
    const [ ShowAddRoster, setShowAddRoster ] = useState(false);
    const [ ShowAddClass, setShowAddClass ] = useState(false);
    const [ Cname, setCname ] = useState("");
    const [ Fname, setFname ] = useState("");
    const [ Lname, setLname ] = useState("");
    const [ Team, setTeam ] = useState("");

    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });  // reducer wrapper
    }

    useEffect(() => {
		console.log("BotAdmin.INIT.60: running useEffect() ", props);

        handleShowTopLevelList("class_group");        // always start with the class list

    }, [1]); 


    useEffect(() => {
        console.log("refresh.386:     RERESH . . . . List=",List, " ShowClassUpdate=",ShowClassUpdate," ClassUpdateDisabled=",ClassUpdateDisabled);
    }, [List, ShowClassUpdate, ClassUpdateDisabled]); 


    useEffect(() => {
    }, [Fname, Lname, Cname, Team, ListHighlight]); 

    useEffect(() => {
            // always show the update btn, but disable if not actionable
            //
            //setShowClassUpdate(true);
            console.log("refresh.378:     . . . . a_roster=", ActiveRoster, " a_dvc=", ActiveDevice, " a_prog=", ActiveProg);
            if (ActiveRoster && ActiveDevice && ActiveProg) {
                setClassUpdateDisabled(false);
                setListHighlight(false);
            } else {
                setClassUpdateDisabled(true);
            }

    }, [ShowClassUpdate, ViewActiveRoster, ViewActiveDevice, ViewActiveProg, ActiveRoster, ActiveDevice, ActiveProg ]);
    
    useEffect(() => {
    }, [ActiveItem, ActiveProg, ActiveRoster, ActiveDevice ]);

    useEffect(() => {
    }, [ ShowNewProgRun, ViewActiveProg ]);

    useEffect(() => {
        if (ListItemIndex >= 0) {
            processListItemSelect(ListItemIndex);
        }
    }, [ ListItemIndex ]);


    // fetch list and setup active state
    //
    const handleShowTopLevelList = async (type) => {
        var outputs = [], list = null, has_list = false, set_list = null;
        console.log("list.246:  # # # # # START FETCH LIST  ", type);
        setListType(type);
        setDisableSetBtn(true);
        //setShowClassUpdate(false);
        switch (type) {
            case "class_group":

                if (true) {     // already read latest classes from db
                    outputs = await fetchClassSetupList()    // read msgs to get classes
                    .then(res => {
                        outputs = [];
                        for (var i = 0; i < res.length; i++) {
                            var data = res[i];
                            var out = Object.assign({}, data);      // copy object
                            out.title = (data.class_name) ? data.class_name : data.users_hash;
                            out.value = data.users_hash;

                            out.disabled = ((data.disabled === "true") || (data.disabled === true)) ? true : false;
                            out.selected = false;
                            outputs.push(out);
                            //console.log("class.536:     . . . . ",i,"  out=", out, " data=",data);
                        }

                        if(outputs.length == 0) {
                            var out = {};
                            out.title = "NO DATA FOUND"
                            out.value = "";
                            out.disabled = false;
                            out.selected = false;
                            outputs.push(out);
                        }

                        // dedup down to one entry per class
                        outputs.sort(arrayGroupIdDesSort);
                        var outputs1 = [];
                        var group_id = 0;
                        for (var o in outputs) {
                            var output = outputs[o];
                            if (output.group_id !== group_id) {
                                outputs1.push(output);
                                group_id = output.group_id;
                            }
                        }
                        console.log("class.529:  CLASS SETUP DB READ ",type," group   orig.len=",outputs.length, "  dedup.len=",outputs1.length);
                        var outputs2 = getActiveRosterList("class_group", outputs1, "show_classes.541");
                        INFO.bot_active_class_groups = outputs2;
                        
                        setList(outputs2);       // presenting by react
                        setListAddText("ADD CLASS")
                        setListTitle("AVAIL CLASSES");
                        return outputs2;
                    })
                    .catch(out => {
                        console.error("get_class_session.552:  FETCH ERROR ", out);
                        return [];
                    });
                    console.log("class.541:      - - - - READ GROUP LIST FROM DB (ENABLED STATES RESET) ",type," group_id=",INFO.bot_group_id, " group list.len=",outputs.length);
                }
                break;


            case "roster_group":
                list = INFO.bot_active_roster_groups;
                has_list = (INFO.bot_active_roster_groups.length > 0) ? true : false;

                if (has_list === true) {
                    console.log("class.502:     - - - - USE LOCAL GROUP LIST CACHE ",type," group_id=",INFO.bot_group_id, " roster list=",list);
                    setList(list);       // presenting by react, this should preserve previous enable states
                    setListTitle("ROSTER GROUPS");
                } 
                
                else {
                    // read group members from db
                    //
                    //outputs = await fetchClassSetupList()
                    //outputs = await fetchGroupMembers()
                    outputs = await fetchGroupList("class")
                    .then(res => {
                        outputs = [];
                        for (var i = 0; i < res.length; i++) {
                            var data = res[i];
                            var out = Object.assign({}, data);      // copy object
                            out.title = data.name;
                            out.value = data.key;

                            out.disabled = ((data.disabled === "true") || (data.disabled === true)) ? true : false;
                            out.selected = false;
                            outputs.push(out);
                            //console.log("class.523:     . . . . ",i,"  out=", out, " data=",data);
                        }

                        if(outputs.length == 0) {
                            var out = {};
                            out.title = "NO DATA FOUND"
                            out.value = "";
                            out.disabled = false;
                            out.selected = false;
                            outputs.push(out);
                        }

                        console.log("class.529:  CLASS SETUP DB READ ",type," group list.len=",outputs.length);
                        outputs = getActiveRosterList("roster", outputs, "show_roster.577");
                        INFO.bot_active_roster_groups = outputs;
                        
                        setList(outputs);       // presenting by react
                        setListAddText(null)
                        setListTitle("ROSTER GROUPS");
                        return outputs;
                    })
                    .catch(out => {
                        console.error("get_class_session.552:  FETCH ERROR ", out);
                        return [];
                    });
                    console.log("class.541:      - - - - READ GROUP LIST FROM DB (ENABLED STATES RESET) ",type," group_id=",INFO.bot_group_id, " group list.len=",outputs.length);
                }

                setListAddText(null)
                break;


            case "device_group":
                list = INFO.bot_active_deivce_groups;
                has_list = (INFO.bot_active_deivce_groups.length > 0) ? true : false;

                if (has_list === true) {
                    console.log("list.412:     - - - - USE LOCAL DEVICE LIST CACHE ",type," group_id=",INFO.bot_group_id, " group list.len=",list.length);
                    setList(list);       // presenting by react, this should preserve previous enable states
                    setListAddText(null)
                    setListTitle(type.toUpperCase()+" GROUPS");
                } 
                
                else {
                    // read group members from db
                    //
                    outputs = await fetchGroupList("device")
                    .then(res => {
                        outputs = [];
                        for (var i = 0; i < res.length; i++) {
                            var data = res[i];
                            var out = Object.assign({}, data);      // copy object
                            out.title = data.name;
                            out.value = data.key;

                            out.disabled = ((data.disabled === "true") || (data.disabled === true)) ? true : false;
                            out.selected = false;
                            outputs.push(out);
                            console.log("group.261:     . . . . ",i,"  out=", out, " data=",data);
                        }

                        if(outputs.length == 0) {
                            var out = {};
                            out.title = "NO DATA FOUND"
                            out.value = "";
                            out.disabled = false;
                            out.selected = false;
                            outputs.push(out);
                        }

                        console.log("list.255:  DEVICE SETUP DB READ ",type," group list.len=",outputs.length);
                        INFO.bot_active_deivce_groups = outputs;
                        
                        setList(outputs);       // presenting by react
                        setListAddText(null)
                        setListTitle("DEVICE GROUPS");
                        return outputs;
                    })
                    .catch(out => {
                        console.error("get_devices.604:  FETCH ERROR ", out);
                        return [];
                    });
                    console.log("list.516:      - - - - READ DEVICE LIST FROM DB (ENABLED STATES RESET) ",type," group_id=",INFO.bot_group_id, " group list.len=",outputs.length);
                }
                setListAddText(null);
                break;

            case "prog_group":
                // list of programs
                //
                outputs = await fetchProgramList("class")
                .then(res => {
                    var outputs = [];
                    var out = {}
                    for (var i = 0; i < res.length; i++) {
                        var data = res[i];
                        var out = Object.assign({}, data);      // copy object
                        out.title = data.name;
                        out.value = data.key;
                        out.param1 = data.param1;

                        out.disabled = ((data.disabled === "true") || (data.disabled === true)) ? true : false;
                        out.selected = false;
                        outputs.push(out);
                        console.log("prog.466:     . . . . ",i,"  out=", out, " data=",data);
                    }

                    if(outputs.length == 0) {
                        var out = {};
                        out.title = "NO DATA FOUND"
                        out.value = "";
                    }

                    // consumed in handleShowAnalyzeVideo()
                    console.log("list.298:   program list.len=",outputs.length);
                    outputs.sort(arraySeqAscSort)

                    //INFO.bot_active_drill_list = outputs;
                    INFO.bot_active_prog_groups = outputs;
                    setList(outputs);
                    setListAddText(null)
                    setListTitle("PROGRAM LIST")
                    return outputs;
                })
                setListAddText(null);
                break;
        }
        setSelectOne(true);     // select one means no state changes

    }


    // insert "add member" button
    //     - this support last-minute add player on the field
    //
    const getActiveRosterList = (mode, list0, from) => {
        var list = JSON.parse(JSON.stringify(list0));

        /*
        var bname = null, bvalue = null;
        switch (mode) {
            case "class_group":
                bname = "Create Class";
                bvalue = "add_class";
                break;
            case "roster":
                bname = "Add User";
                bvalue = "add_user";
                break;
            default:
                console.error("get_active_member.624:   ! ! ! ! !  UNKNOWN MODE: ", mode);
                return null;
        }

        if ((list.length === 0) || (list[0].value !== bvalue)) {
            // insert the "add member" button here
            var add_btn = {}
            add_btn.name = bname;
            add_btn.value = bvalue;
            add_btn.special = true;
            list.unshift(add_btn)
            console.log("group.492:      ADD MEMBER BTN  from=",from," list=",list);
        }
        */

        console.log("group.792:     GET ACTIVE ROSTER:       mode=",mode,"  list0=",list0, "  list=",list, " from=",from);
        for (var i = 0; i < list.length; i++){
            var item = list[i];
            console.log("group.792:             . . . ",i, "    item=",item);
            var disabled = ((item.disabled === true) || (item.disabled === "true")) ? true : false;
            item.disabled = disabled; // preserve old states
            item.selected = false;
            //item.title = (item.title) ? item.title : item.name;
            if(!item.title) {
                if (item.name) {
                    item.title = item.name;
                } else {
                    item.title = parseUserKey(item.child_key);   // KLUDGE: clean up bad data in db
                    item.name = item.title;
                }
            }
        }
        return list;
    }


    // remove special buttons (e.g. "add_user")
    //     - clean it up for backend consumption
    //
    const scrubRosterList = (list) => {
        var out = JSON.parse(JSON.stringify(list));      // copy list
        for (var i = 0; i < out.length; i++){
            if(out[i].special === true) {
                out.splice(i, 1);
            }
        }
        return out;
    }


    function parseUserKey(key) {
        var name = key;

        if (!key) { return null};
        var bits = key.split(":")
        var bits1 = bits[1].split("_");
        if (bits1[0]) {
            if (bits1[0] === "student") {
                var nbits = bits[0].split("_");
                var first = nbits[0].toUpperCase();
                var last = nbits[1].toUpperCase();
                name = first+ " " + last;
            } else if (bits1[0] === "device") {
                var nbits = bits[0].split("_");
                name = nbits[0].toUpperCase();
            }
        }
        return name
    }




    // read student roster
    //     - Use cache version if avail and not blocked
    //
    const readGroupMembers = async (type, owner_hash) => {
        var outputs = [];
        if (!owner_hash) return [];

        if (INFO.bot_read_from_db === false) {
            // check the cache
            switch (type) {
                case "roster":
                    // Note: what is active_roster_list was not set?
                    outputs = getActiveRosterList("roster", INFO.bot_active_roster_list, "init_read_mem_list.663");
                    break;
                case "node":
                    if (INFO.bot_active_node_list && (INFO.bot_active_node_list.length > 0)) {
                        outputs = INFO.bot_active_node_list;
                    }
                    break;
            }

            if (outputs.length > 0) {
                setList(outputs);        // return cached version
                setListTitle(owner_hash.toUpperCase());
                console.log("group.596:       USE CACHED Member  outputs=",outputs, " owner_hash=",owner_hash, " type=",type);
                return outputs;
            }
        }
        //INFO.bot_read_from_db = false;       // one time only
        INFO.bot_read_from_db = true;       // one time only

        console.log("583:  Member  outputs=",outputs, " owner_hash=",owner_hash, " type=",type,"  read_from_db=",INFO.bot_read_from_db);
        outputs = await fetchGroupMembers(owner_hash)
        .then(res0 => {
            var outputs = [];
            var res = map2Array(res0);
            for (var i = 0; i < res.length; i++) {
                var data = res[i];
                var out = Object.assign({}, data);      // copy object

                var name = parseUserKey(data.child_key);
                out.title = name;
                out.name = out.title;

                out.disabled = false;
                if ((data.disabled === "true") || (data.disabled === true) || ((INFO.bot_run_mode === "prog") && (data.auto === true))) {
                    out.disabled = true;
                }
                out.value = data.child_key;
                out.selected = false;
                outputs.push(out);
                console.log("group.405:       MEMBER . . . . ",i,"  name=", data.child_key, " title=",out.title, " out=",out);
            }


            var moutputs = outputs;
            if (type === "roster") {
                moutputs = getActiveRosterList("roster", outputs, "db_read_mem_list.721");    // insert "add user" for new db version
            }
            //console.log("643:     DB Member  moutputs=",moutputs, " outputs=",outputs);
            setList(moutputs);
            setListTitle(owner_hash.toUpperCase());
            return moutputs; 
        })

        return outputs;
    }



    const readProgSequences = async (prog) => {
        var prog_hash = prog.hash;
        if (!prog_hash) return [];

        var res  = await fetchProgSequences(prog_hash);
        if (res) {
            var outputs = [];
            var out1 = {};
            out1.title = "START SYNC";       // Have all slave load drills and wait for next
            out1.value = "start-sync";
            out1.action_hash = CONSTS.BOT_DRILL_START_HASH;    // "_start-sync-session_";
            out1.special = true;
            out1.disabled = false;
            out1.selected = false;
            outputs.push(out1);      // hardcode a "start session" token

            res.sort(arraySeqAscSort);
            for (var i = 0; i < res.length; i++) {
                var data = res[i];

                var bits = data.action_hash.split(":");     // KLUDGE: NEED TO FILTER OUT "sct", backend need to clean up "user" pseq!

                if (bits[0] === "drl") {
                    var out = Object.assign({}, data);      // copy object
                    out.title = data.action_name;
                    out.value = data.action_name;
                    out.disabled = ((data.disabled === "true") || (data.disabled === true)) ? true : false;
                    out.selected = false;
                    outputs.push(out);
                    console.log("prog.288:     . . . . ",i,"  out=", out.action_hash);      //, " data=",data);
                }
            }

            var out2 = {};
            out2.title = "END SYNC";       // Have all slave load drills and wait for next
            out2.value = "end-sync";
            out2.action_hash = CONSTS.BOT_DRILL_END_HASH;      // "_end-sync-session_";
            out2.special = true;
            out2.disabled = false;
            out2.selected = false;
            outputs.push(out2);      // hardcode a "end session" token

            INFO.bot_active_drill_list = JSON.parse(JSON.stringify(outputs));
            INFO.bot_orig_drill_list = JSON.parse(JSON.stringify(outputs));


            setList(outputs);
            setListTitle(prog_hash.toUpperCase());
        }

        return outputs; // consumed in handleShowAnalyzeVideo()
    }



    // View the active list details (roster, drills, nodes) set for this class
    //
    const handleViewActive = async (type) => {
        var active = null, outputs = [], subtype = null, active_list=null, orig_list = null, set_active=null;
        setViewActiveProg(false);
        setViewActiveRoster(false);
        setViewActiveDevice(false);

        //setListType(type);      // prob?
        setDisableSetBtn(true);
        setSelectOne(false);        // detailed list, allow multi-select
        setListAddText(null)
        switch(type) {
            case "roster":
            case "node":
                if (type === "roster") {
                    active = ActiveRoster;
                    setViewActiveRoster(true);
                    subtype = "roster";
                    setListAddText("ADD USER")
                } else {
                    active = ActiveDevice;
                    setViewActiveDevice(true);
                    subtype = "node";
                }
                if (!active) return;

                var owner_hash = active.hash;
                //console.log("view_active.737:    AFTER readGroupMembers()    outputs=",outputs);

                // KLUDGE: Can't figure out how to pass down pointer to an array
                //
                if (type === "roster") {
                    outputs = await readGroupMembers(subtype, owner_hash);
                    var outputs1 = map2Array(outputs);
                    INFO.bot_active_roster_list = JSON.parse(JSON.stringify(outputs1));      // copy list
                    INFO.bot_orig_roster_list = JSON.parse(JSON.stringify(outputs1));
                } else {
                    outputs = await readGroupMembers(subtype, owner_hash);
                    INFO.bot_active_node_list = JSON.parse(JSON.stringify(outputs));        // copy list
                    INFO.bot_orig_node_list = JSON.parse(JSON.stringify(outputs));
                }
                console.log("view_active.606:   SAVED ORIG type=",type, " outputs=",outputs, "  orig_roster_list=",INFO.bot_orig_roster_list,"  orig_node_list=",INFO.bot_orig_node_list);


                break;
            case "drill":
                active = ActiveProg;
                setViewActiveProg(true);
                subtype = "drill";
                if (!active) return;

                var prog_hash = active.hash;
                outputs = await readProgSequences(active);
                //console.log("prog.419:     prog_hash=",prog_hash);
                if (INFO.bot_run_mode === "prog") {
                    setListItemIndex(0);      // indrect start
                    return;
                }

                // if manual clicked
                //
                if (INFO.bot_index_override != null) {
                    console.log("list.667:     . . . OVERRIDE   IndexOverride=",INFO.bot_index_override);
                    setIndexOverride(null);
                    setListItemIndex(INFO.bot_index_override + 1);      // indrect start
                    INFO.bot_index_override = null;

                } else {
                    var msg = null;
                    if(ActiveDevice) {
                        msg = await GetMsg("device", ActiveDevice.hash, INFO.bot_last_msg, INFO.bot_group_id);       // read the latest from backend
                        console.log("list.655:     . . .  CONFIG ACTIVE INDEX, GET LAST MSG   dev_hash=", ActiveDevice.hash, "  ",msg);    //, " outputs=",outputs);
                    }


                    // read Msgs to find out where the Slaves are and point to the "next" Drill (so coach can "activate")
                    if(msg) {
                        // select the next drill
                        //
                        var drill_hash = msg.drill_hash;
                        var outs = loadActiveListState(subtype, outputs);
                        var idx = 0;

                        for (var i = 0; i < outs.length; i++){
                            var state = outs[i];

                            console.log("view_active.657:     . . . ", i, "   drill=",state.hash,"  seleted=",state.selected, "  target_drill=",drill_hash);
                            if (state.hash === drill_hash) {
                                //state.selected = true;
                                idx = i + 1;
                                break;
                            }
                        }

                        setSelectOne(false);
                        setListType(subtype);       // detailed list need diff type

                        //active_list = outs;
                        //set_active(outs);
                        //setActiveListStates(outs);
                        //INFO.bot_orig_active_state = copy2;

                        INFO.bot_active_drill_list = JSON.parse(JSON.stringify(outs));
                        INFO.bot_orig_drill_list = JSON.parse(JSON.stringify(outs));
                        console.log("view_active.580:       DRILL OUT STATES  subtype=",subtype,"  outs=", outs);

                        if (outs[idx]) {
                            setListItemIndex(idx);      // indrect start
                        }

                        return;
                    }
                }

                break;
        }

        setListType(subtype);       // detailed list need diff type
        console.log("list.518:  # # # # # VIEW ACTIVE    type=", type, " subtype=",subtype,"  ",active);    //, " outputs=",outputs);

    }


    // initialize cache copy of the item state (list being displayed)
    //    - merge active state inside the list so we deal with one
    //
    const loadActiveListState = (type, outputs) => {
        var list = [], outs = [], set_state = null, hash = null;
        if (!outputs) return null;

        switch (type) {
            case "roster":
                list = INFO.bot_active_roster_list;
                hash = "hash";
                break;
            case "node":
                list = INFO.bot_active_node_list;
                hash = "hash";
                break;
            case "drill":
                list = INFO.bot_active_drill_list;
                hash = "action_hash";
                break;
        }
        if (list && list.length > 0) {
            // if set already, return what's there
            //
            //var copy = JSON.parse(JSON.stringify(list));
            //setActiveListStates(copy);      // init to disabled state from db
            //return outs;
            console.log("active_state.755:      # # # #   VIEW CACHED ACTIVE LIST STATE  type=",type,"  list=", list);
            return list;
        }

        // load the item disabled states
        //
        outs = [];
        for (var i = 0; i < outputs.length; i++) {
            var item = outputs[i];

            if (!outs[i]) outs[i] = {}

            outs[i].hash = item[hash];
            outs[i].disabled = false;
            outs[i].selected = false;
            if ((item.disabled === "true") || (item.disabled === true)) {
                outs[i].disabled = true;
            }
        }
        var copy = JSON.parse(JSON.stringify(outs));
        list = copy;
        //setActiveListStates(copy);      // init to disabled state from db
        //if (outs) set_state(outs);

        console.log("active_state.525:      # # # #   VIEW ACTIVE LIST STATE   type=",type,"  outs=", outs);
        return outs;
    }



    // EVENT WRAPPER
    //    - Need this to unstrip the event passed in from <>
    //
    const handleListItemSelect = (index) => () => {
        processListItemSelect(index);
    }

    const handleAddNewItem = (index) => () => {
        processAddNewItem(index);
    }



    // create a new item
    //
    function processAddNewItem(type) {

        switch (type) {
            case "class_group":
                setShowAddClass(true);
                INFO.input.cname = "";
                break;
            case "roster":
                // show input form then write to db
                setShowAddRoster(true);
                INFO.input.fname = "";
                INFO.input.lname = "";
                INFO.input.team = "";
                break;
        }
    }




    // select from the list
    //    - click will toggle active state (stored when Set)
    //    - allow multiple selects
    //
    //    TYPES
    //    - class_group: top level class sessions
    //    - roster_group: top level class sessions
    //    - device_group: top level devices group
    //    - prog_group: top level programs
    //    - roster:  detailed roster list
    //    - node:  detailed device list
    //    - drill:  detailed drill list
    //
    //    THREE ITEM STATES:
    //    - default: if db is not disabled and not selected
    //    - selected: if db is clicked
    //    - disabled: if db is clicked twice (cycled from selected to disabled)
    //
    const processListItemSelect = (index) => {
        var active_list = null, orig_list = null;
        if (index === null) return;

        var disabled = null, selected = null;
        setActiveItem(List[index]);
        setDisableSetBtn(false);
        setIndexOverride(index);        // if set, use this instead of reading from Msg
        INFO.bot_index_override = index;

        switch (ListType) {
            case "roster":
                active_list = getActiveRosterList("roster", INFO.bot_active_roster_list, "proc_list.1022a");
                orig_list = getActiveRosterList("roster", INFO.bot_orig_roster_list, "proc_list.1022b");
                break;
            case "node":
                active_list = INFO.bot_active_node_list;
                orig_list = INFO.bot_orig_node_list;
                break;
            case "drill":
                active_list = INFO.bot_active_drill_list;
                orig_list = INFO.bot_orig_drill_list;
                break;

            case "class_group":
                active_list = getActiveRosterList("class_group", INFO.bot_active_class_groups, "proc_list.1058");
                break;
        }

        var list = List.slice(0);       // quick copy
        var outs = List.slice(0);       // quick copy
        //var outs = ActiveListStates.slice(0);
		console.log("click.257:    HANDLE LIST SELECT ", index, " ListType=",ListType, " List=",List); //, " List=",List, " ActiveListStates=",ActiveListStates);
        if (!outs[index]) { console.log("click.813:    OUTS UNDEFINED   index=",index); return;}

        if (SelectOne === true) {
            // simple list select (top level)
            //   - no item state change
            //
            console.log("click.575:          index=",index, " selected=",outs[index].selected, " disabled=", outs[index].disabled);
            selected = outs[index].selected;
            disabled = outs[index].disabled;
            if (outs[index].disabled === false) {
                if (outs[index].selected === false) {
                    for (var i = 0; i < outs.length; i++) {
                        outs[i].selected = false;       // reset all others
                        list[i].selected = false;    // need to chg list to get it displayed
                        //console.log("click.585:       RESET   i=",i, " selected=",outs[i].selected);
                    }
                    selected = true; 
                } else {
                    selected = false; 
                }
            }

        } else {
            // allows multi-select and disabled state
            //
            disabled = false;
            if (outs[index].selected === true) {
                selected = false;
                disabled = true;
            } else {
                
                for (var i = 0; i < outs.length; i++) {
                    outs[i].selected = false;       // reset all others
                    list[i].selected = false;    // need to chg list to get it displayed
                }

                if (outs[index].disabled === true) {
                    selected = false;
                    //disabled = false;
                } else {
                    selected = true;
                    //disabled = true;
                }
            }
        }

        list[index].disabled = disabled;
        list[index].selected = selected;
        setList(list);      // init to disabled state from db
        switch (ListType) {
            case "class_group":
                //var item = INFO.bot_active_class_groups[index];
                //setDisableSetBtn(false);
                break;

            case "roster":
                //var item = INFO.bot_active_roster_list[index];
                setDrillDisabled(!selected);

                if (INFO.bot_active_roster_list[index]) {
                    INFO.bot_active_roster_list[index].disabled = disabled;
                    INFO.bot_active_roster_list[index].selected = selected;
                }
                break;
            case "node":
                if (INFO.bot_active_node_list[index]) {
                    INFO.bot_active_node_list[index].disabled = disabled;
                    INFO.bot_active_node_list[index].selected = selected;
                }
                break;
            case "drill":
                console.log("diff.964:      drill=", INFO.bot_active_drill_list, " index=",index);
                setDrillDisabled(!selected);
                if(INFO.bot_active_drill_list) {
                    INFO.bot_active_drill_list[index].disabled = disabled;
                    INFO.bot_active_drill_list[index].selected = selected;
                }
                break;
        }


        // determine if setup content has chgd and need Save
        //
        var changed = false;
        if(orig_list) {
            if(orig_list.length == outs.length) {
                for (var i = 0; i < outs.length; i++) {
                    var curr = outs[i];
                    var orig = orig_list[i];
                    console.log("diff.730:      _ _ _ _ _  ",i,"  DISABLED  ",orig.hash,"   orig=", orig.disabled, " curr=", curr.disabled);

                    if (curr.disabled !== orig.disabled) {
                        changed = true;
                        console.log("diff.698:       . . . ",i," ",orig.hash, " orig=", orig.disabled, " curr=", curr.disabled);
                    }
                }
            } else {
                console.error("diff.847:     ! ! ! ! !  MISMATCH ACTIVE STATE LEN    orig_list=", orig_list, " outs=", outs);

            }
        }
            
        setSetupChanged(changed);       // two stage chg
        console.log("diff.891:      ACTIVE STATE CHANGED  ",changed, "  orig_list=",orig_list, " outs=",outs);

    }







    // process list specific commands
    //     - create:  create a empty class
    //     - setup:  set a Msg with latest class config (could be prog or drill mode)
    //     - start:  set a Msg to start the drill
    //     - stop:  set a Msg to hold 
    //
    const handleCmd = (cmd) => () => {
        if (!ActiveRoster || !ActiveProg || !ActiveDevice || !INFO.bot_active_roster_list || !INFO.bot_active_node_list) {
            console.error("click.1351:     ! ! ! !  FAILED CONTEXT CMD ", cmd, " ListType=",ListType, " active=",ActiveItem, " active_roster=", INFO.bot_active_roster_list, " active_node_list=", INFO.bot_active_node_list, " bot_mode=",INFO.bot_run_mode);
            return;
        }

        var class_hash = ActiveRoster.hash;
        var prog_hash = ActiveProg.hash;
        var device_hash = ActiveDevice.hash;
        var user_list = scrubRosterList(INFO.bot_active_roster_list);
        var device_list = INFO.bot_active_node_list;
        //var group_id = null;
        var group_id = INFO.bot_group_id;
        console.log("click.1361:     START HANDLE CONTEXT CMD ", cmd, " ListType=",ListType, " active=",ActiveItem, " ActiveProg=",ActiveProg, " active_roster=", INFO.bot_active_roster_list, " active_node_list=", INFO.bot_active_node_list, " bot_mode=",INFO.bot_run_mode);
        switch (cmd) {
            case "create":      // first stage: creates an empty class shell first or changing base config
            case "setup":       // for updating the setup (both prog & drill mode)
                var mode = null;
                group_id = INFO.bot_group_id;
                console.log("start.1186:      CREATE SETUP  group_id=", group_id, " cmd=",cmd);

                setShowClassUpdate(false);
                if ((ActiveProg.type === "prog") || (ActiveProg.mode === "prog")) {
                    mode = "prog";
                } else {
                    mode = "start";
                }
                //SendMsg("abort", mode, INFO.uid, class_hash, prog_hash, device_hash, group_id);   // DO WE NEED THIS?
                //setTimeout(()=> { updateClassSetup("prog", INFO.uid, class_hash, prog_hash, device_hash, user_list, device_list, group_id); }, 2000)
                setTimeout(()=> { updateClassSetup(mode, INFO.uid, class_hash, prog_hash, device_hash, user_list, device_list, group_id); }, 2000)
                break;

            case "prog":        // for starting the prog, will update setup
                // start program mode - run through program before switching user (no pre-drill control)
                //    - need to get server to send progconfig
                //
                var drill_hash = CONSTS.BOT_DRILL_START_HASH;    // "_start-sync-session_";
                console.log("start.1038:      STARTING PROG MODE   devc=",device_hash, " prog=",prog_hash, " class=",class_hash, " drill_hash=",drill_hash, " group_id=",group_id);
                //SendMsg("abort", INFO.uid, "abort", class_hash, prog_hash, device_hash, group_id);
                //setTimeout(()=> { updateClassSetup("prog", INFO.uid, class_hash, prog_hash, device_hash, user_list, device_list, group_id); }, 100)
                setTimeout(()=> { SendMsg("prog", "prog", INFO.uid, drill_hash, class_hash, prog_hash, device_hash, group_id, user_list); }, 3000)
                setShowClassUpdate(false);
                break;

            case "start":
                // start drill mode - run drill for each user and stop
                //    - wait for admin to start next one
                //
                var drill_hash = ActiveItem.action_hash;
                if (INFO.bot_index_override != null) {
                    setListItemIndex(INFO.bot_index_override + 1);
                    INFO.bot_index_override = INFO.bot_index_override + 1;
                } else {
                    setListItemIndex(ListItemIndex + 1);
                }

                if ((ActiveProg.type === "prog") || (ActiveProg.mode === "prog")) {
                    drill_hash = CONSTS.BOT_DRILL_START_HASH;    // "_start-sync-session_";
                    SendMsg("prog", "prog", INFO.uid, drill_hash, class_hash, prog_hash, device_hash, group_id, user_list);  // KLUDGE: HARD CODE TO START FROM TOP
                } else {
                    SendMsg(cmd, "drill", INFO.uid, drill_hash, class_hash, prog_hash, device_hash, group_id, user_list);
                }
                setShowClassUpdate(false);
                break;

            case "abort":
                // stop whatever the slaves are doing
                //
                SendMsg("abort", null, INFO.uid, "abort", class_hash, prog_hash, device_hash, group_id, null);
                setShowClassUpdate(false);
                break;
        }
    }


    // UTIL: check if drills is prog mode
    //
    // KLUDGE: BAD CODE, NEED TO CLEANUP
    function getProgMode(prog) {
        var prog_mode = null;

        INFO.prog_param1 = parseSliceParams(prog.param1);     // custom param overrides
        if (INFO.prog_param1.mode === "prog") {
            INFO.bot_run_mode = "prog";  // go thru entire prog before switching user
            prog.type = "prog";      // auto advance drill for single user
            prog_mode = true;
        } else {
            INFO.bot_run_mode = "drill";
            prog.type = "drill";     // every user does one drill before moving on
            setShowNewProgRun(false);
            prog_mode = false;
        }
        return prog_mode;
    }




    // ADMIN: read setup Msg for this class to restore config (if any)
    //      - use msg.setup if any, this override the static db definition
    //
    const loadClassInfo = async (group, setup0) => {
        var group_id = group.group_id;
        var setup = null;

        console.log("load_class.665:    # # # # #  LOAD CLASS     group_id=",group_id, " setup0=",setup0);
        if (setup0 && (setup0.group_id === group_id)) {
            setup = setup0;     // use what was passed in the msg (latest setup)
            console.log("load_class.1238:           RE-USE OLD SETUP    group_id=",setup.group_id);
        } else {
            var setupz = await fetchClassSetup(group_id);     // read most recent one from db
            var setups = setupz.filter(msg => { return ((msg.subtype == "setup") || (msg.subtype == "prog")) });
            //setups.sort(arrayTimestampDesSort);
            setup = setups[0];
            if (setup) console.log("load_class.1243:           LOAD NEW SETUP FROM MSGS    group_id=",setup.group_id);
        }






        // there is a path on a new instance, it does not read the prev msg.setup.all_user[], which messed up downstream....









        if (setup) {
            // reuse existing setup info
            //
            var device_hash = setup.devices_hash;
            var prog_hash = setup.prog_hash;
            var users_hash = setup.users_hash;
            INFO.bot_setup = JSON.parse(JSON.stringify(setup));
            INFO.bot_setup.users = map2Array(INFO.bot_setup.users);
            INFO.bot_setup.all_users = map2Array(INFO.bot_setup.all_users);
            INFO.bot_group_id = INFO.bot_setup.group_id;

            console.log("load_class.1250:      LOAD CLASS_1    group=",group, " group_id=",INFO.bot_group_id," setup0=",setup0," device=",device_hash, " prog=",prog_hash, " roster=",users_hash);
            INFO.bot_active_node_list = [];    // read in later
            INFO.bot_active_roster_list = [];

            setActiveDevice(null);
            if (device_hash) {
                var nodes = INFO.active_node_list;

                if (device_hash !== "placeholder") {
                    var device = {};
                    device.hash = device_hash;
                    device.title = device_hash;
                    setActiveDevice(device);        // simulate a memberhisp rec
                }
            }

            setActiveProg(null);
            if (prog_hash) {
                var prog = await fetchProgram(prog_hash);
                prog.hash = prog_hash;
                prog.title = prog.name;

                var prog_mode = getProgMode(prog);
                setShowNewProgRun(prog_mode);
                setActiveProg(prog);
            }

            setActiveRoster(null);
            if (INFO.bot_setup.all_users) {
                var users = map2Array(INFO.bot_setup.all_users);
                INFO.bot_active_roster_list = JSON.parse(JSON.stringify(users));      // copy list
                INFO.bot_orig_roster_list = JSON.parse(JSON.stringify(users));
            }

            if (users_hash !== "placeholder") {
                var roster = {};
                roster.hash = users_hash;
                roster.title = users_hash;
                setActiveRoster(roster);        // simulate a memberhisp rec
            }

            console.log("prog.1280:     . . .  LOAD CLASS_2   bot_run_mode=",INFO.bot_run_mode, " group_id=",INFO.bot_group_id," prog=",prog, " dev=",device_hash, " users=",INFO.bot_active_roster_list);
            //var device = await readGroupMembers(device_hash);
            //var prog = await readProgSequences(prog_hash);
        }
    }



    // "set" a class/prog/device to the workset
    //    - If in item list mode, then update
    //
    //    TYPES
    //    - class_group: top level roster group
    //    - device_group: top level devices group, when chg, need to load the list
    //    - prog_group: top level programs
    //
    //    - member:  detailed roster list
    //    - node:  detailed device list
    //    - drill:  detailed drill list
    //
    //
    const handleActivate = async () => {
        var user = null, list = null, show_button = true;
		console.log("click.366:    HANDLE ACTIVATE   type=",ListType,"   ActiveItem=",ActiveItem);

        //setShowClassUpdate(true);     // show only there is chg
        setDisableSetBtn(true);
        switch(ListType) {
            case "class_group":       // roster group
                INFO.bot_active_class_hash = ActiveItem.hash;   // class selected, check for any setup Msg
                INFO.bot_group_id = (ActiveItem.group_id) ? ActiveItem.group_id : INFO.bot_group_id;
                setShowClassUpdate(true);

                var setup = null;       // default is to read from db
                if (INFO.bot_create_new_class === false) {
                    // check to see if the class is active, if not allow activation
                    //    - pass in the class group hash
                    //    - returns current drill and timestamp
                    //
                    //var msg = await GetMsg("class", ActiveItem.hash, null, INFO.bot_group_id);       // read current class state
                    var msg = await GetMsg("class", "admin", null, INFO.bot_group_id);       // read current class state
                    if (msg) {
                        setup = msg.setup;      // load old setup
                        console.log("click.1174:        . . .  CLASS MSG FROM DB   class=",ActiveItem.hash,"  msg=",msg);
                    } else {
                        console.error("click.1571:     ! ! ! ! !  ERROR: READ CLASS, NO MSG FOUND FOR GROUP_ID=",INFO.bot_group_id, " ActiveItem.hash=",ActiveItem.hash);
                    }
                }





                // we should load group_id.setup first so we get the correct all_users[].....the get class API call above is screwed up?







                loadClassInfo(ActiveItem, setup);      // admin: always auto-load
                break;


            case "roster_group":       // roster group
                INFO.bot_active_roster_hash = ActiveItem.hash;      // roster selected
                INFO.bot_group_id = (ActiveItem.group_id) ? ActiveItem.group_id : INFO.bot_group_id;
                setActiveRoster(ActiveItem);        // holds membership rec
                setShowClassUpdate(true);
                break;

            case "prog_group":    // drills group
                if (!ActiveProg) {
                }
                setShowClassUpdate(true);
                //setClassButtonText("UPDATE CLASS");
                //INFO.bot_create_new_class = false;
                //setShowNewProgRun(true);      // BAD!  need to set by prog type!

                setActiveProg(ActiveItem);     // holds prog rec
                var prog_mode = getProgMode(ActiveItem);
                setShowNewProgRun(prog_mode);
                break;

            case "device_group":      // device group
                // read new list from db
                //
                if (!ActiveDevice) {
                    //setClassButtonText("UPDATE CLASS");
                    //INFO.bot_create_new_class = false;
                }

                var outputs = await readGroupMembers("node", ActiveItem.hash);
                INFO.bot_active_node_list = JSON.parse(JSON.stringify(outputs));        // copy list
                INFO.bot_orig_node_list = JSON.parse(JSON.stringify(outputs));

                setShowClassUpdate(true);
                setActiveDevice(ActiveItem);    // holds membership rec
                break;


            // BELOW ARE LOW LEVEL DETAIL LISTS
            //
            case "node": // merge list changes back to INFO.bot_active_node_list[]
            case "roster": // merge list changes back to INFO.bot_active_roster_list[]
                if (ListType === "node") {
                    list = INFO.bot_active_node_list;
                    //user = INFO.bot_active_node_list[i];
                    //set_state = setINFO.bot_active_node_list;
                    //var copy = JSON.parse(JSON.stringify(ActiveListStates));
                    //setActiveNodeStates(copy);
                } else {
                    list = INFO.bot_active_roster_list;
                    //user = INFO.bot_active_roster_list[i];
                    //set_state = setINFO.bot_active_roster_list;
                    //var copy = JSON.parse(JSON.stringify(ActiveListStates));
                    //setActiveMemberStates(copy);
                }
                setShowClassUpdate(true);

                console.log("set_active.1008:     LIST ",ListType,"  . . . list.len=", list);
                if (list) {
                    //for(var i = 0; i < ActiveListStates.length; i++) {
                        //var item = ActiveListStates[i];
                    for(var i = 0; i < list.length; i++) {
                        user = list[i];
                        var item = list[i];
                        var hash = item.hash;
                        var disabled = item.disabled;
                        if (disabled === true) {

                            // set it up so we can write new setup Msg
                            //
                            console.log("set_active.847:     REMOVE ",ListType,"  . . . ", i, " user=",user.child_key, " hash=", hash, "  disabled=",disabled);

                        }
                    }
                }

                console.log("set_active.906:    # # # # # SAVED ACTIVE STATE ",ListType, " list=",list);
                break;

            case "drill":
                console.log("activate.869:    RUN DRILL   last_msg=",INFO.bot_last_msg);
                // read drill from last Msg, select the "next" drill
                //
                break;
        }

        if (SetupChanged === true) {
            //setClassButtonText("UPDATE CLASS");
            setShowClassUpdate(true);
            //INFO.bot_create_new_class = false;
        }
    }


    const handleAddUser = async (e) => {

        //var group_id = INFO.bot_setup.group_id;
        var group_id = INFO.bot_group_id;
        console.log("submit.1420:    SEND NEW USER TO DB  group_id=",group_id, "  setup=",INFO.bot_setup, " fname=",INFO.input.fname, " lname=",INFO.input.lname, " team=",INFO.input.team);
        var res = await SendNewUser("adhoc_user", ActiveRoster.hash, ActiveProg.hash, ActiveDevice.hash, CONSTS.BOT_DRILL_START_HASH, group_id, INFO.input);

        // update the list
        //
        var outputs = await readGroupMembers("roster", ActiveRoster.hash);
        var outputs1 = map2Array(outputs);
        INFO.bot_active_roster_list = JSON.parse(JSON.stringify(outputs1));      // copy list
        INFO.bot_orig_roster_list = JSON.parse(JSON.stringify(outputs1));

        INFO.input = {};
        setShowAddRoster(false);
        setFname("");
        setLname("");
        setTeam("");
        setShowClassUpdate(false);
    }

    const handleDismissAddUser = () => {
        setShowAddRoster(false);
    }


    // Create a new SETUP Msg with nothing in it
    //   - admin then update it with content
    //
    const handleAddClass = async (e) => {
        var group_id = Date.now();      // create new class
        INFO.bot_group_id = group_id;
        INFO.bot_create_new_class = true;       // do not load old class setting

        console.log("submit.1497:    ADD NEW CLASS TO DB   group_id=",group_id, " setup=",INFO.bot_setup, " cname=",INFO.input.cname);
        //var res = await SendNewUser("class", null, null, null, null, group_id, INFO.input);
        var res = await updateClassSetup("class", INFO.uid, INFO.input.cname, null, null, null, null, group_id);

        INFO.input = {};
        setShowAddClass(false);
        setShowClassUpdate(true);
        setDisableSetBtn(true);
        //setClassButtonText("UPDATE CLASS")
        setCname("");

        //INFO.bot_active_class_hash = xxx.hash;
        //setActiveRoster(xxx);

        setIndexOverride(null);
        setListItemIndex(null);      // indrect start
        setListHighlight(true);

        setActiveItem(null);
        setActiveRoster(null);
        setActiveDevice(null);
        setActiveProg(null);
        INFO.bot_active_roster_list = []
        INFO.bot_active_drill_list = []
        INFO.bot_active_deivce_groups = []
        INFO.bot_orig_roster_list = []
        INFO.bot_orig_drill_list = []
        INFO.bot_orig_deivce_groups = []
        INFO.bot_index_override = null;

        setTimeout(async ()=> { 
            var msg = await GetMsg("class", null, null, INFO.bot_group_id);       // read back class state
            if (msg) {
                var setup = msg.setup;      // load old setup
                console.log("add_class.1541:        . . .  RE-READ CLASS MSG FROM DB   setup=",setup," group_id=",INFO.bot_group_id,"  msg=",msg);
                loadClassInfo(msg, setup);      // admin: always auto-load
            } else {
                console.error("add_class.1531:     ! ! ! ! !  ERROR: ADD CLASS, NO MSG FOUND FOR GROUP_ID=",INFO.bot_group_id);
            }
        }, 500)
    }

    const handleDismissAddClass = () => {
        console.log("dismiss.1721:      DISMISS ADD_CLASS");
        setShowAddClass(false);
    }



    const handleInput = (field, value) => {
        //console.log("input.1339:    PROCESS INPUT     field=",field, " input=",value);
        INFO.input[field] = value;
        switch(field) {
            case "cname":
                setCname(value);
                break;
            case "fname":
                setFname(value);
                break;
            case "lname":
                setLname(value);
                break;
            case "team":
                setTeam(value);
                break;
        }
    }

                            /*
                            (ShowNewProgRun === true) ?
                                <Button id="select_btn" disabled={ClassUpdateDisabled} className={classes.cmd_btn} onClick={handleCmd("setup")}>
                                    ACTIVATE PROG
                                </Button>
                                :
                                */


                    //((ViewActiveRoster) || (ViewActiveDevice)) &&
    return (
        <React.Fragment>
	    <div id="bot_root" className={classes.bot_root} >

            {ShowAddClass && <Container id="add_class" className={classes.add_roster_container}>
                <Container id="add_class_form" className={classes.add_roster_form}>
                    <Container id="dismiss" className={Classes.dismiss_summary_container} onClick={handleDismissAddClass} >
                        <FontAwesomeIcon 
                            className={Classes.dismiss_icon}
                            icon={faTimes}
                            style={{ fontSize: "1.5rem", marginTop: "10px"}} />
                    </Container>

                    <h3 className={classes.form_title}> CREATE CLASS </h3>
                    <Container id="add_class_inputs" className={classes.add_roster_inputs}>
                        <TextField
                            label="Class Name"
                            value={Cname}
                            className={classes.input_field}
                            onChange={(e) => handleInput("cname", e.target.value)}
                        />
                        <br />
                    </Container>

                    <Button id="add_class_btn" variant="contained" disabled={false} 
                        className={classes.control_button} onClick={handleAddClass}>
                        CREATE
                    </Button> 
                </Container>
            </Container>}



            {ShowAddRoster && <Container id="add_member" className={classes.add_roster_container}>
                <Container id="add_roster_form" className={classes.add_roster_form}>
                    <Container id="dismiss" className={Classes.dismiss_summary_container} onClick={handleDismissAddUser} >
                        <FontAwesomeIcon 
                            className={Classes.dismiss_icon}
                            icon={faTimes}
                            style={{ fontSize: "1.5rem", marginTop: "10px"}} />
                    </Container>

                    <h3 className={classes.form_title}> ADD USER</h3>
                    <Container id="add_roster_inputs" className={classes.add_roster_inputs}>
                        <TextField
                            label="Team"
                            value={Team}
                            className={classes.input_field}
                            onChange={(e) => handleInput("team", e.target.value)}
                        />
                        <br />
                        <TextField
                            label="First Name"
                            value={Fname}
                            className={classes.input_field}
                            onChange={(e) => handleInput("fname", e.target.value)}
                        />
                        <br />
                        <TextField
                            label="Last Name"
                            value={Lname}
                            className={classes.input_field}
                            onChange={(e) => handleInput("lname", e.target.value)}
                        />
                        <br />
                    </Container>

                    <Button id="add_roster_btn" variant="contained" disabled={false} 
                        className={classes.control_button} onClick={handleAddUser}>
                        ADD
                    </Button> 
                </Container>
            </Container>}



            <Container id="left_big" className={classes.left_container}>
                <Container id="selector_container" className={classes.selector_container}>
                    <Selector id="roster_select" Title="ROSTER" Type="roster_group" Subtype="roster" Highlight={ListHighlight} Active={ActiveRoster} ViewAction={handleViewActive} ListAction={handleShowTopLevelList} />
                    <Selector id="program_select" Title="PROGRAM" Type="prog_group" Subtype="drill" Highlight={ListHighlight} Active={ActiveProg} ViewAction={handleViewActive} ListAction={handleShowTopLevelList} />
                    <Selector id="device_select" Title="DEVICE" Type="device_group" Subtype="node"  Highlight={ListHighlight} Active={ActiveDevice}  ViewAction={handleViewActive} ListAction={handleShowTopLevelList} />
                </Container>

                <Container id="cmd_container" className={classes.cmd_container}>

                    {(ShowClassUpdate) &&
                    <Button id="select_btn" disabled={ClassUpdateDisabled} className={classes.cmd_btn} onClick={handleCmd("create")}>
                        UPDATE CLASS
                    </Button>}


                    {(ViewActiveProg) &&
                    <React.Fragment>

                        {((INFO.bot_run_mode === "drill") ?
                            
                            (ShowNewProgRun === true) ?
                                <Button id="select_btn" disabled={ClassUpdateDisabled} className={classes.cmd_btn} onClick={handleCmd("setup")}>
                                    ACTIVATE PROG
                                </Button>
                                :
                                <Button id="select_btn" disabled={DrillDisabled} className={classes.cmd_btn} onClick={handleCmd("start")}>
                                    ACTIVATE DRILL
                                </Button>

                            :
                            <Button id="select_btn" className={classes.cmd_btn} onClick={handleCmd("prog")}>
                                START PROG
                            </Button>) }

                        <Button id="select_btn" className={classes.cmd_btn} onClick={handleCmd("abort")}>
                            ABORT
                        </Button>

                    </React.Fragment> }

                </Container>
            </Container>

            <Container id="right_big" className={classes.right_container}>
                <div id="description" className={classes.description_container}>
                </div>

                <Container id="list_wrapper" className={classes.list_wrapper}>
                        <div id="list_title" className={classes.title}>{ListTitle}</div>
                        <Container id="list_container" className={classes.list_container}>

                            {ListAddText && <Container className={classes.create_btn} onClick={handleAddNewItem(ListType)} >
                                {ListAddText}
                            </Container>}

                            {List.map( (item, index) => {
                                return (
                                    <Container className={(item.disabled === true) ? classes.disabled_list_item : 
                                                         ((item.selected === true) ?  classes.selected_list_item : classes.list_item)} 
                                                key={"item_"+index} onClick={handleListItemSelect(index)} >
                                        {item.title}
                                    </Container>
                                )}
                            )}
                            <Spacer Height={"90px"} Width={"100%"} />

                        </Container>
                </Container>


                {!DisableSetBtn &&
                <Container id="dev_btn_container" className={classes.dev_btn_container}>
                    {false && <Button id="record_btn" variant="contained" disabled={props.DisableSetBtn} 
                        className={classes.control_button} onClick={handleActivate}>
                        DISABLE
                    </Button>}
                    <Button id="process_btn" variant="contained" disabled={DisableSetBtn} 
                        className={classes.control_button} onClick={handleActivate}>
                        SET
                    </Button> 
                </Container>}

            </Container>

	    </div>

	</React.Fragment>
    )
}




const slave_useStyles = makeStyles(theme => ({
    sbot_root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        position: 'absolute',
        top: '0',
        left: '0',

        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        zIndex: '100',
        background: '#3a3a40',
    },
    sbot_inner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        position: 'absolute',
        top: '0',
        left: '170px',
        width: 'calc(100% - 160px)',
        height: '100%',
        margin: '0',
        padding: '0',
    },
    logo: {
        width: '100px',
        height: '100px',
        margin: '20px',
        zIndex: '0',
        position: 'absolute',
    },
    background: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: '0',
    },
    bot_note_container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        //flexWrap: 'wrap',
        height: '40%',
        width: '100%',
        margin: '15px 0 0 0',
        padding: '0',
        color: '#d7d7c1',
        overflow: 'hidden',
    },
    bot_note_text: {
        display: 'flex',
        fontSize: '2.3rem',
        width: '100%',      //'45%',
        minWidth: '350px',
        height: '60px',
        margin: '0',        //'0 3%',
        padding: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    slave_rank_container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        height: '50%',
        width: '80%',
        maxWidth: '100%',
        justifyItem: 'center',
        margin: '15px 0 0 0',       // '30px auto 30px 140px',      //'30px auto',
        padding: '0',
        color: 'yellow',
        overflow: 'clip',
        //background: 'yellow',
    },
    slave_title_text: {
        width: '100%',
        fontSize: '1.6rem',
        textAlign: 'left',
        margin: '20px 0 5px 0',        //'5px 0',
        minWidth: '350px',
        fontWeight: 'bolder',
        //color: 'red',
    },
    slave_rank_text: {
        width: '100%',
        height: '55px',
        fontSize: '2.1rem',
        textAlign: 'left',
        margin: '0',        //'5px 0',
        //minWidth: '350px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    easter_container: {
        position: 'absolute',
        bottom: '0px',
        width: '8vw',
        height: '8vh',
        zIndex: '1000',
        backgroundColor: '#302e2e8c',
    },
}));

export const BotSlave = (props) => {
    const classes = slave_useStyles();
    const [ Background, setBackground ] = useState(null);                 // poly: active list being displayed
    const [ Ranks, setRanks ] = useState([]);
    const [ Title, setTitle ] = useState("");
    const [ BotSlaveTimer, setBotSlaveTimer ] = useState(null);


    useEffect(() => {
        console.log("slave.843:   # # # # # START   background=",props.Background);
        setBackground(props.Background);

        /*
        var list = [];
        for (var i = 0; i < 13; i++) {list.push(i+": BIG LIST")}
        setRanks(list);
        /**/
    }, [1]); 


    useEffect(() => {
    }, [props.Ranks, props.Notes, Title, Ranks]); 

    useEffect(() => {
        if (typeof(props.Title) == "string") {
            setTitle(props.Title.toUpperCase());
        }
    }, [props.Title]); 

    const handleEasterEgg = (cmd) => event => {
        console.log("easter.2123:  # # # # # # # # #  PROCESS BOT EASTER EGG....")
        switch (cmd) {
            case "stop":
                props.Dismiss();
                break;

            case "dump":
                reportSystemException();
                break;
        }
    }


    return (
        <React.Fragment>
            <div id="sbot_root" className={classes.sbot_root} >
                <img id="logo" src={CONSTS.LOGO_ASSET_PATH+Background} className={classes.logo} />

                <div id="sbot_inner" className={classes.sbot_inner} >
                    <Container className={classes.slave_rank_container} >
                        <Typography className={classes.slave_title_text} >{Title} </Typography>
                        <ScrollList Mode="rank" List={props.Ranks} TextStyle={classes.slave_rank_text} ID={"rank"} />
                    </Container>

                    <div id="bot_note" className={classes.bot_note_container} > 
                        <Typography className={classes.slave_title_text} >NEXT UP</Typography>
                        <ScrollList Mode="list" List={props.Notes} TextStyle={classes.bot_note_text} ID={"note"} />
                    </div>

                    <div key="easter3_btn" id="easter_right" className={classes.easter_container}  style={{right: '0px' }} onClick={handleEasterEgg("stop")}/>
                </div>

                <div key="easter1_btn" id="easter_left" className={classes.easter_container}  style={{left: '0px' }} onClick={handleEasterEgg("dump")}/>
            </div>
        </React.Fragment>
    )

}